export type Bonus = {
  number: string
  name: string
  subtitle: string
  summary: string
  details: string
  items: string[]
  closing: string
  tagline: string
  pages: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Crochet Bag Charms & Keychains',
    subtitle: '15 Step-by-Step Patterns',
    summary: 'Give your handmade bags a playful finishing touch with miniature crochet charms and keychains.',
    details:
      'Create colorful little accessories to attach to handbags, use as keychains, or give as handmade gifts.',
    items: [
      'Cherry Bag Charm',
      'Strawberry Keychain',
      'Daisy Bag Charm',
      'Heart Keychain',
      'Bow Bag Charm',
      'Butterfly Charm',
      'Sunflower Keychain',
      'Star Bag Charm',
      'Miniature Handbag Keychain',
      'Five-Petal Flower Charm',
      'Mushroom Keychain',
      'Lemon Bag Charm',
      'Botanical Leaf Cluster',
      'Mini Teddy Bear Keychain',
      'Customizable Initial Charm',
    ],
    closing: 'Each design includes the relevant pieces, stitch instructions, assembly details, and attachment methods.',
    tagline: '15 Cute Accessories to Personalize Your Favorite Bags.',
    pages: '40 Pages of Patterns & Practical References',
    value: 12,
  },
  {
    number: '02',
    name: 'Crochet Wallets & Mini Pouches',
    subtitle: '10 Step-by-Step Patterns',
    summary: 'Create beautiful accessories to match your handmade handbags.',
    details:
      'Discover coin purses, folding wallets, compact card holders, zipper pouches, and other practical projects.',
    items: [
      'Classic Crochet Coin Purse',
      'Modern Zipper Pouch',
      'Folding Crochet Wallet',
      'Minimalist Crochet Card Holder',
      'Granny Square Coin Purse',
      'Button-Closure Mini Pouch',
      'Elegant Flap Wallet',
      'Crochet Glasses Case',
      'Crochet Cosmetic Pouch',
      'Floral Coin Purse',
    ],
    closing: 'Explore different closures, compartments, pocket constructions, and finishing details.',
    tagline: 'Matching Accessories That Make Your Crochet Collection Even More Versatile.',
    pages: '40 Pages of Patterns & Practical References',
    value: 12,
  },
  {
    number: '03',
    name: 'Cute Crochet Mini Bags',
    subtitle: '8 Step-by-Step Patterns',
    summary: 'Love little handbags?',
    details: 'Explore eight mini bag designs with beautiful textures, playful shapes, and modern details.',
    items: [
      'Mini Cloud Crochet Bag',
      'Mini Ribbon Shoulder Bag',
      'Mini Checkerboard Bag',
      'Mini Crescent Crossbody',
      'Mini Shell-Shaped Bag',
      'Mini Puff Stitch Purse',
      'Mini Envelope Crossbody',
      'Mini Scalloped Edge Bag',
    ],
    closing: 'Each pattern covers its body construction, shaping, handles, straps, closures, and finishing details.',
    tagline: "Eight Adorable Designs You'll Want to Make in Different Colors.",
    pages: '40 Pages of Patterns & Practical References',
    value: 15,
  },
  {
    number: '04',
    name: '3D Crochet Flowers & Decorations',
    subtitle: '12 Step-by-Step Patterns',
    summary: 'Add beautiful dimension, color, and personality to your handmade crochet bags.',
    details:
      'Discover layered flowers, elegant botanical leaves, and decorative appliqués that can be attached to your creations.',
    items: [
      'Layered 3D Rose Appliqué',
      'Dimensional Tulip Bloom',
      'Textured Dahlia Flower',
      '3D Peony Crochet Flower',
      'Orchid Crochet Appliqué',
      'Lavender Sprig Decoration',
      'Hibiscus Crochet Flower',
      '3D Camellia Appliqué',
      'Succulent Rosette Decoration',
      'Eucalyptus Leaf Branch',
      'Monstera Leaf Appliqué',
      'Mixed 3D Floral Bouquet Appliqué',
    ],
    closing: 'Each design includes the required petals, leaves, shaping, assembly, and attachment guidance.',
    tagline: 'Turn a Simple Bag Into Something Beautifully Personal.',
    pages: '40 Pages of Patterns & Practical References',
    value: 12,
  },
  {
    number: '05',
    name: 'Matching Crochet Accessories',
    subtitle: '10 Step-by-Step Patterns',
    summary:
      'Make useful crochet accessories that complement your handbags and help organize everyday essentials.',
    details: 'From water bottle holders to compact organizers, this bonus adds functional projects to your collection.',
    items: [
      'Crochet Water Bottle Holder',
      'Crochet Earbud Case Cover',
      'Crochet Phone Sleeve',
      'Crochet Sunglasses Holder',
      'Crochet Hand Sanitizer Holder',
      'Crochet Lip Balm Holder',
      'Crochet Travel Tissue Holder',
      'Crochet Cable & Charger Organizer',
      'Crochet Pen & Hook Roll Organizer',
      'Crochet Mini Tech Accessory Organizer',
    ],
    closing:
      'Each project includes appropriate measurements, construction instructions, functional components, closures, and finishing.',
    tagline: 'Practical Little Projects. Beautiful Handmade Details. More Ways to Use Your Crochet Skills.',
    pages: '40 Pages of Patterns & Practical References',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const offerDescription = '105 Ready-to-Follow Crochet Patterns in One Complete Digital Collection'

export const checkoutFeatures = [
  '105 Ready-to-Follow Crochet Patterns',
  '50 Crochet Bag Designs',
  '55 Additional Bonus Projects',
  '5 Complete Volumes + 5 FREE Bonus Books',
  '10 Downloadable PDF Books',
  '400 Total Pages',
  'Step-by-Step Instructions',
  'Yarn, Measurements & Stitch Counts',
  'Assembly & Finishing Guidance',
  'Instant Digital Access',
  '7-Day Guarantee',
]
